<template>
    <el-dialog v-model="dialogShow" width="400px" center @close="closeEvent" modal-class="dialog-new-model">
        <div class="login-container">
            <div class="login-title">密码重置
            </div>
            <div class="login-form">
                <el-form ref="loginRef" :model="formData" :rules="formRules">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item prop="phone">
                                <el-input v-model="formData.phone" placeholder="请输入手机号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="5">
                        <el-col :span="16">
                            <el-form-item prop="imgcode">
                                <el-input v-model="formData.imgcode" placeholder="请输入图形验证码"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <div class="loginCodeImg" v-if="loginCodeImg" @click="getImgCode">
                                <img :src="loginCodeImg" />
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="5">
                        <el-col :span="16">
                            <el-form-item prop="code">
                                <el-input v-model="formData.code" placeholder="请输入验证码"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-button color="#ef8b25" plain @click="getCode">{{codeTime?`${codeTime}秒重新获取`:'获取验证码'}}</el-button>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item prop="password">
                                <el-input v-model="formData.password" placeholder="请输入密码" type="password" show-password></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div style="margin:0 0 20px;">
                <el-checkbox v-model="formData.flag">
                    我已阅读并同意
                    <span class="activeColor" @click.stop="policyShow=true">《用户协议》</span>和
                    <span class="activeColor" @click.stop="privacyShow=true">《隐私政策》</span>
                </el-checkbox>
            </div>
            <div>
                <el-button style="width:100%" color="#ef8b25" class="footer-btn1" @click="registerEvent">确认修改</el-button>
            </div>
            <div>
                <el-divider>
                    <span style="font-size:12px;">我知道密码！
                        <span class="activeColor" style="cursor:pointer;" @click="closeEvent">返回登陆</span>
                    </span>
                </el-divider>
            </div>
        </div>

        <policy-dialog :popupShow="policyShow" v-if="policyShow" @close="policyShow=false"></policy-dialog>
        <privacy-dialog :popupShow="privacyShow" v-if="privacyShow" @close="privacyShow=false"></privacy-dialog>
    </el-dialog>
</template>
<script lang="ts" setup>
import policyDialog from "./policyDialog.vue"
import privacyDialog from "./privacyDialog.vue"
import { ref, reactive, onMounted, defineProps, defineEmits } from 'vue';
import { forgetPassword, sendCode, getUserInfo, getCaptcha } from "@/api/common.js"
import { ElMessage } from 'element-plus'
import { useStore } from "vuex"
import { useRouter } from 'vue-router';
const router = useRouter();
const store = useStore();
const props = defineProps({
    popupShow: {
        type: Boolean,
        default: false
    }
})
const dialogShow = ref(props.popupShow)
const loginRef = ref()
const formData = ref({
    phone: '',
    code: '',
    password: '',
    flag: false,
    imgcode: ''
})
const policyShow = ref(false)
const privacyShow = ref(false)
const codeTime = ref(0)
let codeTimer = null
const loginCodeImg = ref()
let nowUuid = ''
const emitList = defineEmits(['close'])
const formRules = {
    phone: [
        {
            message: '请输入手机号',
            required: true
        }
    ],
    password: [
        {
            message: '请输入密码',
            required: true
        }
    ],
    code: [
        {
            message: '请输入验证码',
            required: true
        }
    ],
    imgcode: [
        {
            message: '请输入图形验证码',
            validator: (rule: any, value: any, callback: any) => {
                if (!value) {
                    callback(new Error("请输入图形验证码"))
                }
                callback()
            }
        }
    ],
}

function registerEvent() {
    loginRef.value.validate(valid => {
        if (valid) {
            if (!formData.value.flag) {
                return ElMessage.warning('请先阅读用户协议和隐私政策');
            }
            const params = {
                ...formData.value
            }
            console.log(params)
            forgetPassword(params).then(res => {
                console.log(res)
                sessionStorage.setItem('token', res.data)
                getUserInfo().then(res => {
                    store.dispatch('setLogin', res.data);
                    emitList('close')
                    router.go(0)

                })
            }).catch(err => {
                console.log(err)
            })
        }
    })
}

function closeEvent() {
    emitList('close')
}

function getCode() {
    if (codeTime.value > 0) {
        return ElMessage.warning('倒计时结束后再发送')
    } else {
        let token = sessionStorage.getItem('token')
        loginRef.value.validateField(['phone', 'imgcode'], valid => {
            if (valid) {
                const params = {
                    phone: formData.value.codephone,
                    type: token ? '04' : '03',
                    uuid: nowUuid
                }
                console.log(params)
                sendCode(params).then(res => {
                    ElMessage.success('验证码已发送')
                    codeTime.value = 60
                    codeTimer = setInterval(() => {
                        if (!codeTime.value) {
                            clearInterval(codeTimer)
                            codeTimer = null
                        } else {
                            codeTime.value--;
                        }
                    }, 1000)
                }).catch(err => {
                    console.log(err)
                })
            }
        })
    }
}
function getImgCode() {
    const randomNum = Math.floor(Math.random() * (99999999 - 10000000 + 1)) + 10000000;
    const uuid = `${randomNum}-${new Date().getTime()}`
    getCaptcha({
        uuid: uuid
    }).then(res => {
        loginCodeImg.value = 'data:image/png;base64,' + res.data;
        nowUuid = uuid
    })
}
onMounted(() => {
    let token = sessionStorage.getItem('token')
    if (token) {
        let userInfo = sessionStorage.getItem('userInfo')
        formData.value.phone = userInfo.userPhone;
    }
    getImgCode()
})
</script>
<style lang="scss" scoped>
@import "@/style/variable.scss";
.login-container {
    padding: 10px;
    .login-title {
        font-size: 20px;
        font-weight: bold;
        color: $base-text-color;
        margin-bottom: 10px;
    }
    .login-tabs {
        display: flex;
        font-weight: bold;
        color: $base-text-color;
        &>div {
            width: 100px;
            text-align: center;
            line-height: 24px;
        }
        .active {
            color: $base-color;
            border-bottom: 2px solid $base-color;
        }
    }
    .login-form {
        margin: 20px 0 0;
    }
    .loginCodeImg {
        width: 102px;
        height: 32px;
        img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>


<style lang="scss">
.dialog-new-model {
    .el-dialog {
        background: url("@/assets/img/bg2.jpg") no-repeat;
        background-size: 100% 100%;
        .el-divider__text {
            background-color: transparent;
        }
    }
}
</style>